export default __webpack_public_path__ + "static/media/servico-placeholder-small.8b8d7ddf.png";